import { useEffect, useState } from 'react';
import AuthPanel from '../components/AuthPanel';
import SiteHeader from '../components/SiteHeader';
import Footer from '../components/Footer';
import useAuthModal from '../hooks/useAuthModal';

export default function AuthScreen() {
  const authModal = useAuthModal();
  const [bounceMessage, setBounceMessage] = useState(null);

  // Surface a "session expired" notice when the global 401 handler bounced
  // the user here mid-work (e.g. mid-question-generation, JWT expired during
  // a long-running call). The api client writes a flag into sessionStorage;
  // we read it once and clear it.
  useEffect(() => {
    try {
      const reason = sessionStorage.getItem('auth-bounce-reason');
      if (reason) {
        sessionStorage.removeItem('auth-bounce-reason');
        const isB2B = reason === 'b2b-session-expired';
        setBounceMessage(
          isB2B
            ? 'Your B2B session expired. Please log in again — any unsaved work was lost.'
            : 'Your session expired. Please log in again.',
        );
      }
    } catch { /* sessionStorage unavailable — silently skip */ }
  }, []);

  return (
    <div className="min-h-screen bg-[#F6F7FB]">
      <SiteHeader authModal={authModal} />
      <div className="flex items-center justify-center px-4 py-10">
        <div className="w-full max-w-md">
          {bounceMessage && (
            <div
              role="alert"
              className="mb-4 rounded-2xl border border-amber-200 bg-amber-50 px-4 py-3 text-sm text-amber-800"
            >
              {bounceMessage}
            </div>
          )}
          <AuthPanel mode="route" />
        </div>
      </div>
      <Footer />
    </div>
  );
}
